import { Component, Input, Output, forwardRef, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'wl-autocomplete-nolabel',
  templateUrl: './autocomplete-nolabel.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteNoLabelComponent),
      multi: true
    },
  ]
})
export class AutocompleteNoLabelComponent implements ControlValueAccessor {
  
  @Input() label: string;
  @Input() placeholder: string;
  @Input() required = false;
  @Input() options: any[] = [];
  @Output() selected = new EventEmitter<string>();
  @Input() autoClick: boolean;
  @Input() disabled = false;

  filteredOptions: any[] = [];

  private _text: any;
  get text(): any {
    return this._text;
  }
  set text(v: any) {
    this._text = v;
    this.onChange(v);
    this.filterOptions(v); // Filter options whenever text changes
  }
  
  @ViewChild('firstNameInput') nameInputRef: ElementRef;

  constructor(private changeDetection: ChangeDetectorRef) {
    this.placeholder = this.label;
  }

  private onChange = (_) => { };

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    console.log(this.autoClick);
    if (changes && this.autoClick) {
      this.nameInputRef.nativeElement.click();
    }

    if (changes['options']) {
      console.log(this.options);
      this.filterOptions(this.text); // Re-filter options when options input changes
    }
  }

  private onTouched = () => { };

  writeValue(value: any) {
    this.text = value;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  filterOptions(text: string) {
    if (text) {
      this.filteredOptions = this.options.filter(s => new RegExp(`^${text}`, 'gi').test(s.name));
    } else {
      this.filteredOptions = this.options;
    }
    this.changeDetection.detectChanges(); // Trigger change detection
    console.log(this.filteredOptions); // Debug filtered options
  }

  check(val: any) {
    console.log('Selected', val);
    this.selected.emit(val);
  }
}
